import { SEND_PROMOTION_CODE, CLEAR_PROMOTION_VALUE } from "app/actionTypes";
import axios from "app/utils/http/http";
import env from "app/utils/env";

export const sendPromotionCode = promotionCode => {
	return {
		type: SEND_PROMOTION_CODE,
		promise: axios.post(`${env("QUOTE_API_URL")}/promoCode`, promotionCode, {
			headers: {
				"Content-type": "application/json",
			},
		}),
	};
};

export const clearPromotionValue = payload => {
	return {
		type: CLEAR_PROMOTION_VALUE,
		promise: axios.post(`${env("QUOTE_API_URL")}/promoCode`, payload, {
			headers: {
				"Content-type": "application/json",
			},
		}),
	};
};
